<template>
    <div>
        <div style="text-align: right;">
            <span class="material-symbols-outlined" v-on:click="toggle" style="cursor: pointer; ">
                help
            </span>
        </div>
        <div v-if="visible" style="padding: 20px 0 0 0;">
            <app-content v-bind:name="name"></app-content>
        </div>
    </div>
</template>
<script>
import AppContent from './content.vue'
export default {
    components: { AppContent },
    data: function () {
        return {
            visible: false
        }
    },
    props: ['name'],
    methods: {
        toggle: function () {
            this.visible = !this.visible;
        }
    }
}
</script>
<style></style>
